import { render, staticRenderFns } from "./characterprops.vue?vue&type=template&id=252db312&"
import script from "./characterprops.vue?vue&type=script&lang=js&"
export * from "./characterprops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('252db312')) {
      api.createRecord('252db312', component.options)
    } else {
      api.reload('252db312', component.options)
    }
    module.hot.accept("./characterprops.vue?vue&type=template&id=252db312&", function () {
      api.rerender('252db312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/characterprops.vue"
export default component.exports